import { render, staticRenderFns } from "./RegraICMS.vue?vue&type=template&id=056beacc&scoped=true"
import script from "./RegraICMS.vue?vue&type=script&lang=js"
export * from "./RegraICMS.vue?vue&type=script&lang=js"
import style0 from "./RegraICMS.vue?vue&type=style&index=0&id=056beacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056beacc",
  null
  
)

export default component.exports